import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { CdkScrollable, ScrollDispatcher } from '@angular/cdk/scrolling';
import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Inject,
    NgZone,
    OnDestroy,
    OnInit,
    ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Client } from '../../../../../projects/kiene-core/src/lib/components/client/classes/client';
import { ConfirmDialogInput } from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog';
import { ConfirmDialogComponent } from '../../../../../projects/kiene-core/src/lib/components/dialogs/confirm-dialog/confirm-dialog.component';
import { Gruppe } from '../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { GruppenService } from '../../../../../projects/kiene-core/src/lib/components/gruppen/gruppen.service';
import { API_BASE_URL_SERVICE } from '../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { LocalStorageService } from '../../../../../projects/kiene-core/src/lib/services/local-storage/local-storage.service';
import { ChangeCurrentClientService } from '../../../administration/client/change-current-client/change-current-client.service';
import { KieneTableService } from '../../../components/kiene-table/kiene-table.service';
import { AddTourDialogComponent } from '../../../components/tourenplan/add-tour-dialog/add-tour-dialog.component';
import { AbgabebelegChargeDialogComponent } from '../../../dialogs/abgabebeleg-charge-dialog/abgabebeleg-charge-dialog.component';
import { MessageService } from '../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneUtils } from '../../../../../projects/kiene-core/src/lib/utils/KieneUtils';
import { BestellungInternPosition } from '../../../wa-wi/bestellung-intern/bestellung-intern-position';
import { Indikation } from '../../../warehouse/material/artikel-indikation/indikation';
import { Anwendung } from '../../behandlungsanfrage/anwendung';
import { Identifikation } from '../../behandlungsanfrage/identifikation';
import { BelegPositionInlineResult } from '../../beleg-position/beleg-position-inline/beleg-position-inline';
import { BelegPositionInlineComponent } from '../../beleg-position/beleg-position-inline/beleg-position-inline.component';
import { GruppeDialogInput } from '../../gruppenverwaltung/gruppenuebersicht/gruppe-dialog/gruppe-dialog';
import { GruppeDialogComponent } from '../../gruppenverwaltung/gruppenuebersicht/gruppe-dialog/gruppe-dialog.component';
import { GruppeEditDialogComponent } from '../../gruppenverwaltung/gruppenuebersicht/gruppe-edit-dialog/gruppe-edit-dialog.component';
import { AbgabebelegService } from '../abgabebeleg.service';
import { HoherPreisDialogComponent, HoherPreisDialogInput } from './hoher-preis-dialog/hoher-preis-dialog.component';
import { MeldungKorrekturDialogComponent } from './meldung-korrektur-dialog/meldung-korrektur-dialog.component';
import { PositionDetailsDialogComponent } from './position-details-dialog/position-details-dialog.component';
import { GruppeTier } from '../../../../../projects/kiene-core/src/lib/components/gruppe-tier/classes/gruppe-tier';
import { AbgabebelegPosition } from '../../../../../projects/kiene-core/src/lib/components/abgabebelege/classes/abgabebeleg-position';
import {
    Abgabebeleg,
    AbgabebelegCharge,
    AbgabebelegStatus,
    PositionCharge,
} from '../../../../../projects/kiene-core/src/lib/components/abgabebelege/classes/abgabebeleg';
import { Tierarzt } from '../../../../../projects/kiene-core/src/lib/components/tieraerzte/classes/tierarzt';
import {
    abgabebelegAaId,
    abgabebelegAaIdEquals,
    hatAbgabebelegAaId,
    istAbgabebelegChargenArtikel,
    istAbgabebelegPositionInlineLadbar,
    mergeAbgabebelegPositionChargen,
} from '../abgabebeleg-position.utils';

export class AbgabebelegPositionErledigt {
    position: AbgabebelegPosition;
    erledigt: boolean;

    constructor(position: AbgabebelegPosition, erledigt: boolean) {
        this.position = position;
        this.erledigt = erledigt;
    }
}

@Component({
    selector: 'kiene-abgabebeleg-details',
    templateUrl: './abgabebeleg-details.component.html',
    styleUrls: ['./abgabebeleg-details.component.scss'],
    host: { '(window:keydown)': 'checkForArrowKeys($event)' },
})
export class AbgabebelegDetailsComponent implements OnInit, AfterViewInit, OnDestroy {
    readonly abgabebelegAaIdEquals = abgabebelegAaIdEquals;

    @ViewChild('belegPosition') belegPosition: BelegPositionInlineComponent;
    @ViewChild('belegPositionContainer') belegPositionContainer: ElementRef;
    @ViewChild('positionTableContainer') positionTableContainer: ElementRef;
    belegPositionContainerPosition = 0;
    stickyFlag = false;
    positionHeadline = 'Positionen';
    timeMeasuring = undefined;

    @ViewChild('clientGroupSelect') clientGroupSelect: MatSelect;

    abgabebeleg: Abgabebeleg = new Abgabebeleg();

    descriptionCtrl: UntypedFormControl = new UntypedFormControl();

    tierartCtrl: UntypedFormControl = new UntypedFormControl();
    clientGroupCtrl = new UntypedFormControl();
    clientGroups: Gruppe[] = [];
    groupPinned = true;

    aktPosition: AbgabebelegPosition;

    /** Chargen-Snapshot pro Position – Schutz vor DB-Löschung bei Speichern ohne Chargen im JSON. */
    private chargenSnapshot = new Map<number, PositionCharge[]>();

    gebuehrenbelegCtrl = new UntypedFormControl(false);

    identifikationen: Observable<Identifikation[]>;
    indikationen: Indikation[] = [];
    anwendungen: Anwendung[] = [];

    einzelpreisSubscription: Subscription = null;
    tierartSubscription: Subscription = null;
    anwendungSubscription: Subscription = null;
    abgabebelegSubscription: Subscription = null;
    neighboursSubsciption: Subscription = null;
    indikationSubscription: Subscription = null;

    datumCtrl: UntypedFormControl = new UntypedFormControl();

    isLoading = false;
    isSaving = false;
    neuverschreibung = false;

    changeCustomer = false;

    watchClientSubscription: Subscription;

    @ViewChild('amountInput')
    amountInput: ElementRef;

    @ViewChild('materialInput')
    materialInput: ElementRef;

    @ViewChild('chargePickerInput')
    chargePickerInput: ElementRef;

    @ViewChild('pickStoragePlaceInput')
    pickStoragePlaceInput: ElementRef;

    @ViewChild('pickAmountInput')
    pickAmountInput: ElementRef;

    @ViewChild('dosingInput')
    dosingInput: ElementRef;

    @ViewChild('tierartSelect')
    tierartSelect: MatSelect;

    @ViewChild('anwendungSelect')
    anwendungSelect: MatSelect;

    @ViewChild('indikationSelect')
    indikationSelect: MatSelect;

    // query parameters for getting the neighbours of the entry
    orderby: string;
    search: string;

    positionenMitFehlendenChargenListe: AbgabebelegPositionErledigt[] = [];
    currentUserIsPhitoAdmin = false;

    constructor(
        private localStorageService: LocalStorageService,
        private route: ActivatedRoute,
        private router: Router,
        private gruppenService: GruppenService,
        private messageService: MessageService,
        public dialog: MatDialog,
        private currentClientService: ChangeCurrentClientService,
        private kieneTableService: KieneTableService,
        private location: Location,
        private abgabebelegService: AbgabebelegService,
        private scrollDispatcher: ScrollDispatcher,
        private ngZone: NgZone,
        private changeDetector: ChangeDetectorRef,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
    ) {
        this.route.queryParams.subscribe(params => {
            this.orderby = params['orderby'];
            this.search = params['search'];
        });
    }

    hasPermission(id: number) {
        return this.localStorageService.hasPermission(id);
    }

    canShowUnlockButton(): boolean {
        const currentUser = this.localStorageService.getCurrentUser();
        if (!currentUser) {
            return false;
        }
        if (currentUser.admin > 0) {
            return true;
        }
        if (!currentUser.tierarzt_id) {
            return true;
        }
        return KieneUtils.sameId(this.abgabebeleg?.tierarzt_id, currentUser.tierarzt_id);
    }

    setzeAktuellePosition(pos: AbgabebelegPosition) {
        this.aktPosition = pos;
        if (this.isEditingAllowed() && istAbgabebelegPositionInlineLadbar(pos)) {
            this.belegPosition?.ladePosition(pos);
            if (!this.groupPinned) {
                this.gruppenService.getGruppePraxissoftware(pos?.gruppe_id).subscribe({
                    next: response => {
                        this.setClientGroup(<Gruppe>response);
                    },
                });
            }
        }
    }

    gibGruppenbezeichnung(group: Gruppe) {
        if (group) {
            let bez = group.bezeichnung; // + ' - ' + group.kunde;
            if (group.alter_wochen) {
                bez += ' - Alter: ' + group.alter_wochen + 'W';
            }
            if (group.herdenname) {
                bez += ' - ' + group.herdenname;
            }
            if (group.stall) {
                bez += ' - ' + group.stall;
            }
            if (group.anzahl_tiere_aktuell) {
                bez += ' - T: ' + group.anzahl_tiere_aktuell;
            }
            return bez;
        }
        return '';
    }

    gibAbgabebelegNr() {
        if (this.isNewAbgabebeleg()) {
            return 'Neu';
        }
        if (this.abgabebeleg?.abgabebeleg_nr) {
            return this.abgabebeleg.abgabebeleg_nr;
        }
        return 'ID:' + this.abgabebeleg?.abgabebeleg_id;
    }

    isNewAbgabebeleg() {
        return !this.abgabebeleg.abgabebeleg_id;
    }

    setKunde(knd: Client) {
        this.abgabebeleg.kunde_id = knd.kunde_id;
        this.abgabebeleg.kunde = knd.bezeichnung_final;
        this.abgabebeleg.tierbewegung_melden = knd.tierbewegung_melden;
        this.abgabebeleg.selbstimpfer = knd.selbstimpfer;
        this.abgabebeleg.betriebsart_kaelbermast = knd.kaelbermast;
        this.abgabebeleg.betriebsart_ohrmarke = knd.ohrmarke;
        this.loadGruppen();
    }

    ngOnInit() {
        const windowRef: ElementRef = new ElementRef<any>(window);
        this.scrollDispatcher.register(new CdkScrollable(windowRef, this.scrollDispatcher, this.ngZone));
        this.scrollDispatcher.scrolled().subscribe((data: CdkScrollable) => {
            const yPosition = data.getElementRef().nativeElement.scrollTop;
            this.checkScrollPosition(yPosition);
        });
        this.currentUserIsPhitoAdmin = this.localStorageService.isCurrentUserPhitoUser();

        this.watchClientSubscription = this.localStorageService.watchCurrentClient().subscribe(client => {
            if (client && (!this.abgabebeleg.kunde_id || this.changeCustomer)) {
                this.setKunde(client);
                this.gruppenService.getStandardGruppePraxissoftware(client.kunde_id).subscribe(response => {
                    if (response?.records?.length > 0) {
                        const gruppe = response.records[0];
                        this.setClientGroup(response.records[0]);
                        this.abgabebeleg.positionen.forEach(pos => {
                            pos.gruppe_id = gruppe.gruppe_id;
                            pos.gruppe = gruppe.bezeichnung;
                        });
                        this.save(this.abgabebeleg.status_id, null, null, true);
                    }
                });
                this.changeCustomer = false;
            }
        });

        this.loadGruppen();

        const id = this.route.snapshot.paramMap.get('id');
        if (id !== null) {
            if (id === 'neu') {
                // neuer Abgabebeleg

                if (this.localStorageService.getCurrentClient() !== null) {
                    const knd = this.localStorageService.getCurrentClient();
                    this.setKunde(knd);
                }

                // this.autocompleteMaterial();
                this.datumCtrl.setValue(new Date());
                this.abgabebeleg.status_id = AbgabebelegStatus.ERSTELLT;
                const user = this.localStorageService.getCurrentUser();
                if (user.tierarzt_id) {
                    this.abgabebeleg.tierarzt_id = user.tierarzt_id;
                    this.abgabebeleg.tierarzt = user.vorname + ' ' + user.nachname;
                }

                if (!this.abgabebeleg?.kunde_id) {
                    this.currentClientService.openChangeDialog();
                }
            } else {
                // Gespeicherter Abgabebeleg

                this.loadAbgabebeleg(Number.parseInt(id, 10));
            }
        }
    }

    ngAfterViewInit() {
        this.belegPositionContainerPosition = this.belegPositionContainer?.nativeElement?.offsetTop;
        if (this.abgabebeleg && this.abgabebeleg.kunde_id && !this.clientGroupCtrl.value) {
            this.gruppenService.getStandardGruppePraxissoftware(this.abgabebeleg.kunde_id).subscribe(response => {
                if (response?.records?.length > 0) {
                    this.setClientGroup(response.records[0]);
                }
            });
        }

        const client = this.localStorageService.getCurrentClient();
        setTimeout(() => {
            let focusGruppe = false;
            if (client) {
                if (client.kaelbermast > 0 || client.rechnung_gruppe) {
                    focusGruppe = true;
                }
            }

            if (focusGruppe) {
                this.belegPosition?.setFocusOnInit(false);
                this.clientGroupSelect?.focus();
            } else {
                this.belegPosition?.setFocusOnInit(true);
                this.belegPosition?.setFocusArticleAutocomplete();
            }

            this.checkIsEditingAllowed();
        }, 300);
    }

    loadGruppen() {
        if (this.abgabebeleg.kunde_id) {
            let params = new HttpParams().set('kunde_id', this.abgabebeleg.kunde_id.toString());
            params = params.append('orderby', 'einstalldatum_von desc');
            this.kieneTableService.get(this.apiBaseUrl + 'gruppe/read_beleg.php', params).subscribe({
                next: response => {
                    this.clientGroups = response.records ?? [];
                    // Nach asynchronem Laden der Optionen Auswahl erneut aus der Liste setzen
                    // (sonst bleibt mat-select wegen Stub-Objekt / String-vs-Number-ID leer).
                    this.setClientGroup(this.clientGroupCtrl.value);
                },
                error: err => {
                    this.messageService.errorMessage(
                        'Es konnten keine Gruppen zu dem Kunden mit der ID ' +
                            this.abgabebeleg.kunde_id +
                            ' geladen werden!',
                        err,
                    );
                },
            });
        }
    }

    /** Setzt die Gruppe im Select; bevorzugt das Objekt aus clientGroups (gleiche Referenz wie mat-option). */
    private setClientGroup(gruppe: Gruppe | null | undefined) {
        if (!gruppe || gruppe.gruppe_id == null) {
            return;
        }
        const fromList = this.clientGroups?.find(g => KieneUtils.sameId(g.gruppe_id, gruppe.gruppe_id));
        this.clientGroupCtrl.setValue(fromList ?? gruppe);
    }

    clientGroupComparator(cg1: Gruppe, cg2: Gruppe) {
        if (cg1 && cg2) {
            return KieneUtils.sameId(cg1.gruppe_id, cg2.gruppe_id);
        }
        return false;
    }

    checkIsEditingAllowed() {
        if (!this.isEditingAllowed()) {
            this.datumCtrl.disable();
            this.clientGroupCtrl.disable();
        } else {
            this.datumCtrl.enable();
            this.clientGroupCtrl.enable();
        }
    }

    ngOnDestroy() {
        if (this.watchClientSubscription) {
            this.watchClientSubscription.unsubscribe();
        }
        if (this.tierartSubscription) {
            this.tierartSubscription.unsubscribe();
        }
        if (this.anwendungSubscription) {
            this.anwendungSubscription.unsubscribe();
        }
        if (this.abgabebelegSubscription) {
            this.abgabebelegSubscription.unsubscribe();
        }
        if (this.neighboursSubsciption) {
            this.neighboursSubsciption.unsubscribe();
        }
        if (this.einzelpreisSubscription) {
            this.einzelpreisSubscription.unsubscribe();
        }
        if (this.indikationSubscription) {
            this.indikationSubscription.unsubscribe();
        }
    }

    gruppeBearbeiten() {
        const dialogRef = this.dialog.open(GruppeEditDialogComponent, {
            width: '520px',
            maxWidth: '95vw',
            data: { gruppe: this.clientGroupCtrl.value },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.setClientGroup(result);
            }
            this.clientGroupSelect?.focus();
        });
    }

    gruppeEditierbar(): boolean {
        if (this.clientGroupCtrl.value) {
            return this.clientGroupCtrl.value.bezeichnung !== 'Standard';
        } else {
            return false;
        }
    }

    isPositionEditingVisible() {
        return (
            this.abgabebeleg.status_id === AbgabebelegStatus.ERSTELLT ||
            this.abgabebeleg.status_id === AbgabebelegStatus.WIRD_KORRIGIERT
        );
    }

    isEditingAllowed() {
        return !!(
            (!this.isLoadingOrSaving() && this.isPositionEditingVisible() && this.abgabebeleg.kunde_id) ||
            this.isNewAbgabebeleg()
        );
    }

    unlock() {
        this.kieneTableService.post(this.apiBaseUrl + 'abgabebeleg/korrigieren.php', this.abgabebeleg, null).subscribe({
            next: () => {
                this.messageService.infoMessage('Der Abgabebeleg wurde wieder geöffnet!');
                this.reload();
            },
            error: err => {
                this.messageService.errorMessage('Fehler! Der Abgabebeleg konnte nicht geöffnet werden!', err);
                this.reload();
            },
        });
    }

    reload() {
        if (!this.abgabebeleg.abgabebeleg_id) {
            return;
        }
        this.loadAbgabebeleg(this.abgabebeleg.abgabebeleg_id);
    }

    loadAbgabebeleg(abgabebelegId: number) {
        this.isLoading = true;

        this.abgabebelegSubscription?.unsubscribe();
        this.abgabebelegSubscription = this.kieneTableService
            .getOne(this.apiBaseUrl + 'abgabebeleg/read_one.php', 'abgabebeleg_id', abgabebelegId.toString())
            .subscribe({
                next: (response: Abgabebeleg) => {
                    this.abgabebeleg = response;
                    this.neuverschreibung = !!this.abgabebeleg?.abgabebeleg_id_neuverschreibung;

                    this.loadGruppen();

                    if (this.localStorageService.getCurrentClient() !== null) {
                        if (!this.abgabebeleg.kunde_id) {
                            this.setKunde(this.localStorageService.getCurrentClient());
                        }
                    }

                    /**
                     * Wenn noch keine Position ausgewaehlt, dann Standardgruppe setzen. Ansonsten die Gruppe der
                     * letzten Position.
                     */
                    if (this.abgabebeleg.positionen.length > 0) {
                        const cp = this.abgabebeleg.positionen[this.abgabebeleg.positionen.length - 1];
                        const gruppeId = cp?.gruppe_id;

                        this.gruppenService.getGruppePraxissoftware(gruppeId).subscribe({
                            next: (gruppe: Gruppe) => {
                                this.setClientGroup(gruppe);
                            },
                            error: err => {
                                this.messageService.errorMessage(
                                    'Die Gruppe mit der ID ' + gruppeId + ' konnte nicht geladen werden!',
                                    err,
                                );
                            },
                        });
                    } else {
                        this.gruppenService.getStandardGruppePraxissoftware(this.abgabebeleg.kunde_id).subscribe({
                            next: resp => {
                                if (resp?.records?.length > 0) {
                                    this.setClientGroup(resp.records[0]);
                                }
                            },
                        });
                    }

                    if (!this.abgabebeleg.tierarzt_id || !this.abgabebeleg.abgabebeleg_nr) {
                        const user = this.localStorageService.getCurrentUser();
                        if (user.tierarzt_id) {
                            this.abgabebeleg.tierarzt_id = user.tierarzt_id;
                            this.abgabebeleg.tierarzt = user.vorname + ' ' + user.nachname;
                        }
                    }

                    this.datumCtrl.setValue(this.abgabebeleg.datum);
                    this.descriptionCtrl.setValue(this.abgabebeleg.bezeichnung);

                    this.updateChargenSnapshot();

                    // this.loadNeighbours();

                    this.isLoading = false;
                    this.checkIsEditingAllowed();
                },
                error: err => {
                    this.messageService.errorMessage('Fehler beim Laden des Belegs!', err);
                    this.isLoading = false;
                    this.checkIsEditingAllowed();
                },
            });
    }

    gibGesamtpreis() {
        let gesamtpreis = 0.0;
        for (const p of this.abgabebeleg.positionen) {
            if (p.abrechnen > 0) {
                if (p.einzelpreis !== null && p.einzelpreis !== undefined && p.einzelpreis > 0) {
                    if (p.artikelmenge !== null && p.artikelmenge !== undefined && p.artikelmenge > 0) {
                        gesamtpreis += p.einzelpreis * p.artikelmenge;
                    }
                }
            }
        }
        return gesamtpreis;
    }

    savePositionen(result: BelegPositionInlineResult) {
        if (result?.positionen?.length > 0) {
            let insertCharge = result?.insertChargen;
            let lastPos: AbgabebelegPosition = null;
            let hinzugefuegt = false;
            for (const posi of result?.positionen) {
                let ok = false;
                if (!hatAbgabebelegAaId(posi)) {
                    if (this.neuverschreibung) {
                        this.messageService.alertMessage(
                            'Bei einer Neuverschreibung kann kein Artikel hinzugefügt werden!',
                        );
                    } else {
                        this.abgabebeleg.positionen.push(posi);
                        ok = true;
                    }
                } else {
                    const index = this.abgabebeleg.positionen.findIndex(p => abgabebelegAaIdEquals(p.aa_id, posi.aa_id));
                    if (index >= 0) {
                        mergeAbgabebelegPositionChargen(posi, this.abgabebeleg.positionen[index]);
                        this.abgabebeleg.positionen.splice(index, 1, posi);
                        ok = true;
                    }
                }
                if (ok) {
                    if (Number(posi.stueckliste) > 0) {
                        insertCharge = true;
                    }
                    lastPos = posi;
                }
                hinzugefuegt = hinzugefuegt || ok;
            }
            if (hinzugefuegt) {
                this.scrollToBottom();
                this.save(this.abgabebeleg.status_id, insertCharge, lastPos?.position, true);
            }
        }
    }

    impfkontrollbuecherAbschliessen(kunde_id: number, datum: Date, tierarzt_id: number) {
        this.abgabebelegService.getOffeneImpfkontrollbuecher(kunde_id, datum).subscribe({
            next: response => {
                if (response?.count > 0) {
                    this.abgabebelegService.offeneImpfbuecherAbschliessen(datum, response.records, tierarzt_id, false);
                }
            },
            error: err => {
                this.messageService.errorMessage('Impfkontrollbücher konnten nicht geladen werden!', err);
            },
        });
    }

    /**
     * positionIndex: 1-basiert
     */ save(statusId: number, insertMissingCharge: boolean, positionIndex: number, gotoNextPos: boolean): void {
        if (this.abgabebeleg.status_id === AbgabebelegStatus.ABGESCHLOSSEN) {
            this.messageService.errorMessage('Abgabebeleg wurde bereits abgeschlossen', null);
            return;
        }

        if (!this.abgabebeleg.kunde_id) {
            this.messageService.errorMessage('Bitte einen Kunden auswählen!', null);
            return;
        }

        // als Gebuehrenbeleg abspeichern
        if (this.localStorageService.hasPermission(1240)) {
            if (this.gebuehrenbelegCtrl.value) {
                statusId = 48;
            }
        }

        if (statusId === 42) {
            const hohePositionen = [];
            const kritischerPreis = 5000;

            this.abgabebeleg.positionen.forEach(pos => {
                const positionspreis: number = Math.round(pos.einzelpreis * pos.artikelmenge * 100) / 100;
                if (positionspreis >= kritischerPreis) {
                    const hpdi = new HoherPreisDialogInput();
                    hpdi.preis = positionspreis;
                    hpdi.position = pos.position;
                    hpdi.artikel = pos.artikel_me;
                    hpdi.menge = pos.artikelmenge;

                    hohePositionen.push(hpdi);
                }
            });
            if (hohePositionen.length > 0) {
                this.dialog
                    .open(HoherPreisDialogComponent, { data: hohePositionen })
                    .afterClosed()
                    .subscribe({
                        next: result => {
                            if (!result) {
                                this.isSaving = false;
                                return;
                            }
                            this.performSave(statusId, insertMissingCharge, gotoNextPos, positionIndex);
                        },
                    });
                return;
            }
        }

        this.performSave(statusId, insertMissingCharge, gotoNextPos, positionIndex);
    }

    initMissingChargeDialog() {
        const positionen = this.abgabebeleg.positionen;

        for (const p of positionen) {
            if (istAbgabebelegChargenArtikel(p)) {
                const sollmenge = p.artikelmenge;
                if (sollmenge > 0) {
                    let chargenmengen = 0;
                    for (const c of p.chargen) {
                        chargenmengen += c.chargenmenge;
                    }
                    // es fehlen noch chargen
                    if (sollmenge > chargenmengen) {
                        this.positionenMitFehlendenChargenListe.push(new AbgabebelegPositionErledigt(p, false));
                    }
                }
            }
        }
    }

    openMissingChargeDialog() {
        const missingPosition = this.getNextMissingChargePosition();

        if (missingPosition != null) {
            if (!this.abgabebeleg.tierarzt_id) {
                this.messageService.alertMessage('Dieser Beleg ist keinem Tierarzt zugewiesen!');
                return;
            }

            const dialogRef = this.dialog.open(AbgabebelegChargeDialogComponent, {
                data: { abgabebelegPosition: missingPosition, tierarztId: this.abgabebeleg.tierarzt_id },
            });

            dialogRef.afterClosed().subscribe(response => {
                if (response) {
                    const chargen: AbgabebelegCharge[] = response;
                    const positionChargen: PositionCharge[] = [];
                    for (const c of chargen) {
                        if (c.menge_beleg > 0) {
                            const charge: PositionCharge = new PositionCharge();
                            charge.charge_id = c.charge_id;
                            charge.chargenmenge = c.menge_beleg;
                            charge.lagerplatz_id = c.lagerplatz_id;
                            positionChargen.push(charge);
                        }
                    }

                    missingPosition.chargen = positionChargen;
                    this.updatePositionInAbgabebeleg(missingPosition);
                }
                this.positionIstErledigt(missingPosition);
                this.openMissingChargeDialog();
            });
        } else {
            this.save(this.abgabebeleg.status_id, false, null, true);
        }
    }

    updatePositionInAbgabebeleg(missingPosition: AbgabebelegPosition) {
        const positionIndex = this.abgabebeleg.positionen.findIndex(p =>
            abgabebelegAaIdEquals(p.aa_id, missingPosition.aa_id),
        );
        this.abgabebeleg.positionen.splice(positionIndex, 1, missingPosition);
    }

    positionIstErledigt(missingPosition: AbgabebelegPosition) {
        const positionIndex = this.positionenMitFehlendenChargenListe.findIndex(
            pe => abgabebelegAaIdEquals(pe.position.aa_id, missingPosition.aa_id),
        );
        this.positionenMitFehlendenChargenListe[positionIndex].erledigt = true;
    }

    getNextMissingChargePosition(): AbgabebelegPosition {
        for (const pe of this.positionenMitFehlendenChargenListe) {
            if (!pe.erledigt) {
                return pe.position;
            }
        }
        // alles erledigt
        return null;
    }

    goBack() {
        window.history.go(-1);
    }

    isLoadingOrSaving() {
        return this.isLoading || this.isSaving;
    }

    checkScrollPosition(yPosition: number) {
        const pos = yPosition + 64;
        if (pos >= this.belegPositionContainerPosition) {
            if (!this.stickyFlag) {
                // this.stickyFlag = true;
                this.changeDetector.detectChanges();
                this.positionHeadline = 'Positionen true';
            }
        } else {
            if (this.stickyFlag) {
                // this.stickyFlag = false
                this.changeDetector.detectChanges();
                this.positionHeadline = 'Positionen false';
            }
        }
    }

    checkForArrowKeys(event) {
        const keyPressed: string = event.code;
        setTimeout(() => {}, 200);

        if (event.altKey && event.code === 'F10') {
            const activeElement = document.activeElement;
            activeElement.classList.add('active-element');
        } else if (event.code === 'F12') {
            this.save(AbgabebelegStatus.ERSTELLT, false, null, true);
        }

        if ((keyPressed.startsWith('Numpad') || keyPressed.startsWith('Digit')) && !this.isKeyEventFromInput(event)) {
            let numberString: string;
            if (keyPressed.startsWith('Digit')) {
                numberString = keyPressed.split('Digit')[1];
            } else {
                numberString = keyPressed.split('Numpad')[1];
            }
            const pos = Number.parseInt(numberString, 10);
            const position = this.abgabebeleg.positionen[pos - 1];
            if (position) {
                this.setzeAktuellePosition(position);
            }
        }
    }

    editCustomer() {
        const confInput = new ConfirmDialogInput();
        confInput.headline = 'Kunde ändern?';
        confInput.text =
            'Wenn Sie den Kunden ändern, werden für alle vorhandenen Positionen die Gruppen auf die Standardgruppe des neuen Kunden gesetzt.';
        confInput.okButton = 'Ändern';
        this.dialog
            .open(ConfirmDialogComponent, { data: confInput })
            .afterClosed()
            .subscribe({
                next: result => {
                    if (result) {
                        this.changeCustomer = true;
                        this.currentClientService.openChangeDialog();
                    }
                },
            });
    }

    getArt(pos: AbgabebelegPosition) {
        if (pos.behandlung > 0) {
            return 'B';
        }
        return 'A';
    }

    sortPositions() {
        const positions = [];
        // erst Behandlungen
        for (const p of this.abgabebeleg.positionen) {
            if (p.behandlung > 0) {
                positions.push(p);
            }
        }
        // dann den Rest (=Abgaben)
        for (const p of this.abgabebeleg.positionen) {
            if (p.behandlung <= 0) {
                positions.push(p);
            }
        }
        this.abgabebeleg.positionen = positions;
    }

    openGruppeAddDialog(event) {
        event.stopPropagation();
        if (this.abgabebeleg?.kunde_id) {
            this.kieneTableService
                .getOne(this.apiBaseUrl + 'kunde/read_one.php', 'kunde_id', this.abgabebeleg?.kunde_id?.toString())
                .subscribe({
                    next: (kunde: Client) => {
                        const input = new GruppeDialogInput(kunde, false, undefined);
                        this.dialog
                            .open<GruppeDialogComponent, GruppeDialogInput, Gruppe>(GruppeDialogComponent, {
                                data: input,
                            })
                            .afterClosed()
                            .subscribe(gruppe => {
                                if (gruppe) {
                                    this.setClientGroup(gruppe);
                                    this.loadGruppen();
                                }
                            });
                    },
                    error: err => {
                        this.messageService.errorMessage('Fehler beim Laden des Kunden!', err);
                    },
                });
        }
    }

    setTierarzt(vet: Tierarzt) {
        this.abgabebeleg.tierarzt_id = vet.tierarzt_id;
        this.abgabebeleg.tierarzt = vet.vorname + ' ' + vet.nachname;
    }

    getTiereString(tiere: GruppeTier[]) {
        let text = '';
        if (tiere) {
            for (const t of tiere) {
                text += t.ohrmarke + ', ';
            }
            if (text?.endsWith(', ')) {
                text = text.substring(0, text.length - 2);
            }
        }
        return text;
    }

    getIdentifikationText(position: AbgabebelegPosition) {
        if (!position) {
            return null;
        }
        let text = position?.identifikation;

        if (position.tiere && position.tiere.length > 0) {
            if (position.tiere.length < 10) {
                text = this.getTiereString(position.tiere);
            } else {
                text = position.tiere.length + ' Tiere ausgewählt';
            }
        }

        return text;
    }

    drop(event: CdkDragDrop<AbgabebelegPosition[]>) {
        if (event.previousIndex === event.currentIndex) {
            return;
        }
        moveItemInArray(this.abgabebeleg.positionen, event.previousIndex, event.currentIndex);
        this.save(this.abgabebeleg.status_id, false, null, true);
    }

    addGruppeVisible() {
        return (
            KieneUtils.isApiZero(this.abgabebeleg?.tierbewegung_melden) &&
            this.localStorageService.hasPermission(1902) &&
            (!this.clientGroupCtrl.value || this.clientGroupCtrl.value.bezeichnung === 'Standard')
        );
    }

    openAbgabebelegPdf() {
        this.abgabebelegService.openAbgabebelegGesamtPdf(this.abgabebeleg, this.abgabebeleg?.kunde_id);
    }

    getStatusMeldungTooltipHit(p: AbgabebelegPosition) {
        let tooltip = '';
        if (p.status_id_hit) {
            tooltip += 'HIT Meldung: ' + p.status_hit;
            if (p.gemeldet_hit) {
                const d = new Date(p.gemeldet_hit);
                tooltip += ' am: ' + d.toLocaleDateString('de-DE');
                tooltip += ' um: ' + d.toLocaleTimeString('de-DE');
            }
        }
        return tooltip;
    }

    getStatusMeldungTooltipQs(p: AbgabebelegPosition) {
        let tooltip = '';
        if (p.status_id_qs) {
            tooltip += 'QS Meldung: ' + p.status_qs;
            if (p.gemeldet_qs) {
                const d = new Date(p.gemeldet_qs);
                tooltip += ' am: ' + d.toLocaleDateString('de-DE');
                tooltip += ' um: ' + d.toLocaleTimeString('de-DE');
            }
        }
        return tooltip;
    }

    isMeldungStatus(statusId: number | string, ...expected: number[]): boolean {
        return KieneUtils.includesId(expected, statusId);
    }

    fehlerhafteMeldungKorrigieren(position: AbgabebelegPosition, event?: Event) {
        event?.stopPropagation();
        const dialogRef = this.dialog.open(MeldungKorrekturDialogComponent, {
            data: { position: position, abgabebeleg: this.abgabebeleg },
        });

        dialogRef.afterClosed().subscribe({
            next: () => {
                this.reload();
            },
        });
    }

    openPositionDetailsDialog(p: AbgabebelegPosition) {
        this.dialog
            .open(PositionDetailsDialogComponent, { data: { p: p, abgabebeleg: this.abgabebeleg } })
            .afterClosed()
            .subscribe({
                next: (result: boolean) => {
                    if (result === true) {
                        this.aktPosition = null;
                        this.belegPosition?.felderLeeren(true);
                        this.belegPosition?.setFocusArticleAutocomplete();
                        this.reload();
                    }
                },
            });
    }

    gruppeChanged(matSelectChange: MatSelectChange) {
        const gruppe = <Gruppe>matSelectChange.value;
        if (gruppe && gruppe.gruppe_id) {
            if (this.aktPosition) {
                this.aktPosition.gruppe_id = gruppe.gruppe_id;
                this.aktPosition.gruppe = gruppe.bezeichnung;
                this.save(this.abgabebeleg.status_id, false, null, false);
            }
        }
    }

    protected scrollToBottom(): void {
        setTimeout(() => {
            this.positionTableContainer.nativeElement.scroll({
                top: this.positionTableContainer.nativeElement.scrollHeight,
                left: 0,
                behavior: 'smooth',
            });
        }, 100);
    }

    private performSave(
        statusId: number,
        insertMissingCharge: boolean,
        gotoNextPos: boolean,
        positionIndex: number,
    ): void {
        this.isSaving = true;

        this.abgabebeleg.status_id = statusId;
        this.abgabebeleg.bezeichnung = this.descriptionCtrl.value;
        this.abgabebeleg.datum = this.datumCtrl.value;

        this.restoreMissingChargenBeforeSave();

        const beforePut = performance.now();
        this.kieneTableService.updateEntity(this.apiBaseUrl + 'abgabebeleg/update.php', this.abgabebeleg).subscribe({
            next: response => {
                const afterPut = performance.now();
                this.abgabebeleg = response;
                this.updateChargenSnapshot();
                if (this.abgabebeleg.dbhinweis) {
                    this.messageService.hintMessage(this.abgabebeleg.dbhinweis);
                } else {
                    this.messageService.infoMessage('Der Abgabebeleg wurde erfolgreich gespeichert!');
                }
                // setze URL von /neu auf /abgabebelegId
                this.location.replaceState('belege/abgabebelege/' + this.abgabebeleg.abgabebeleg_id);

                this.isSaving = false;

                if (this.abgabebeleg.status_id === AbgabebelegStatus.ABGESCHLOSSEN && this.abgabebeleg.kunde_id) {
                    this.impfkontrollbuecherAbschliessen(
                        this.abgabebeleg.kunde_id,
                        this.abgabebeleg.datum,
                        this.abgabebeleg.tierarzt_id,
                    );
                }

                // oeffne den Chargendialog fuer alle Positionen, bei denen die Chargenangaben nicht komplett sind.
                if (statusId !== AbgabebelegStatus.ABGESCHLOSSEN && insertMissingCharge === true) {
                    this.initMissingChargeDialog();
                    this.openMissingChargeDialog();
                } else {
                    // nach dem abschliessen pdf anzeigen
                    if (statusId === AbgabebelegStatus.ABGESCHLOSSEN) {
                        const dialogRef = this.abgabebelegService.openAbgabebelegGesamtPdf(
                            this.abgabebeleg,
                            this.abgabebeleg?.kunde_id,
                        );

                        dialogRef.subscribe({
                            next: dialogClosed => {
                                if (dialogClosed) {
                                    const params = new HttpParams().set(
                                        'abgabebeleg_id',
                                        this.abgabebeleg.abgabebeleg_id.toString(),
                                    );
                                    this.kieneTableService
                                        .get(this.apiBaseUrl + 'abgabebeleg/read_artikel_tourenplan.php', params)
                                        .subscribe({
                                            next: tourResp => {
                                                const positionen: BestellungInternPosition[] = tourResp.records;
                                                const c = new Client();
                                                c.kunde_id = this.abgabebeleg.kunde_id;
                                                c.bezeichnung_final = this.abgabebeleg.kunde;
                                                if (positionen && positionen.length > 0) {
                                                    const tourDialogRef = this.dialog.open(AddTourDialogComponent, {
                                                        data: { positionen: positionen, client: c },
                                                    });
                                                    tourDialogRef.afterClosed().subscribe(() => {
                                                        this.router.navigate(['/belege', 'abgabebelege']).then();
                                                    });
                                                } else {
                                                    this.router.navigate(['/belege', 'abgabebelege']).then();
                                                }
                                            },
                                            error: err => {
                                                this.messageService.errorMessage(
                                                    'Fehler beim Lesen der möglichen Tourenplan Artikel!',
                                                    err,
                                                );
                                            },
                                        });
                                }
                            },
                        });
                    }
                }

                if (gotoNextPos === true) {
                    if (positionIndex > 0 && positionIndex < this.abgabebeleg?.positionen?.length) {
                        const pos = this.abgabebeleg.positionen[positionIndex];
                        this.setzeAktuellePosition(pos);
                    } else {
                        this.aktPosition = null;
                        this.belegPosition?.felderLeeren(true);
                        this.belegPosition?.setFocusArticleAutocomplete();
                    }
                }

                this.checkIsEditingAllowed();

                const saveFinished = performance.now();
                this.timeMeasuring =
                    'PUT:' + Math.round(afterPut - beforePut) + 'ms WORK:' + Math.round(saveFinished - afterPut) + 'ms';
            },
            error: error => {
                this.messageService.errorMessage('Der Abgabebeleg konnte nicht gespeichert werden!', error);
                this.isSaving = false;
                this.abgabebeleg.status_id = AbgabebelegStatus.ERSTELLT;
                this.checkIsEditingAllowed();
            },
        });
    }

    private isKeyEventFromInput(event: KeyboardEvent): boolean {
        if (event.target instanceof Node) {
            switch (event.target.nodeName) {
                case 'INPUT':
                case 'SELECT':
                case 'TEXTAREA':
                    return true;
                default:
                    return false;
            }
        }
        return false;
    }

    private updateChargenSnapshot(): void {
        this.chargenSnapshot.clear();
        for (const p of this.abgabebeleg?.positionen ?? []) {
            const id = abgabebelegAaId(p);
            if (id > 0 && p.chargen?.length) {
                this.chargenSnapshot.set(
                    id,
                    p.chargen.map(c => ({ ...c })),
                );
            }
        }
    }

    /** Beim Speichern löscht die DB alle Chargen und legt sie nur aus dem JSON neu an. */
    private restoreMissingChargenBeforeSave(): void {
        for (const p of this.abgabebeleg?.positionen ?? []) {
            if (!istAbgabebelegChargenArtikel(p) || p.chargen?.length) {
                continue;
            }
            const id = abgabebelegAaId(p);
            const snap = id > 0 ? this.chargenSnapshot.get(id) : undefined;
            if (snap?.length) {
                p.chargen = snap.map(c => ({ ...c }));
            }
        }
    }
}
